'use client';

export type HeaderDropdownId = 'language' | 'collection' | 'category';

const HEADER_DROPDOWN_OPEN_EVENT = 'lytra-header-dropdown-open';

export function notifyHeaderDropdownOpen(id: HeaderDropdownId) {
  window.dispatchEvent(
    new CustomEvent(HEADER_DROPDOWN_OPEN_EVENT, {
      detail: { id },
    })
  );
}

export function subscribeToHeaderDropdownOpen(
  currentId: HeaderDropdownId,
  onOtherDropdownOpen: () => void
) {
  const handleDropdownOpen = (event: Event) => {
    const { detail } = event as CustomEvent<{ id?: HeaderDropdownId }>;

    if (detail?.id && detail.id !== currentId) {
      onOtherDropdownOpen();
    }
  };

  window.addEventListener(HEADER_DROPDOWN_OPEN_EVENT, handleDropdownOpen);

  return () => {
    window.removeEventListener(HEADER_DROPDOWN_OPEN_EVENT, handleDropdownOpen);
  };
}
